import { getImageUrlBasedOnContainerWidth } from "@pb/utils/image/getImageUrl";
const type = 'PRODUCT_IMAGE';
const containerWidth = 122; // Product image container width from cart-composition
const useDevPrefixedUrl = process.env.USE_DEV_PREFIXED_LIQUID_PIXELS_URLS === 'enabled';
const getImageUrl = (src) => {
    return getImageUrlBasedOnContainerWidth({ src, type, containerWidth, useDevPrefixedUrl });
};
export const getAddToBagVerificationCompositionProduct = (data, tableData) => {
    var _a;
    return {
        sku: data.variantCode || '',
        name: data.name || '',
        image: {
            url: getImageUrl(data.image),
            label: data.imageAltText || '',
        },
        price: data.price || '',
        size: typeof (tableData === null || tableData === void 0 ? void 0 : tableData[1].value) === 'string' ? tableData === null || tableData === void 0 ? void 0 : tableData[1].value : '',
        color: typeof (tableData === null || tableData === void 0 ? void 0 : tableData[2].value) === 'string' ? tableData === null || tableData === void 0 ? void 0 : tableData[2].value : '',
        discountedPrice: data.reducedPrice,
        previousPrice: ((_a = data.priorPrice) === null || _a === void 0 ? void 0 : _a.formattedValue) || '',
        quantity: typeof (tableData === null || tableData === void 0 ? void 0 : tableData[0].value) === 'string' ? tableData === null || tableData === void 0 ? void 0 : tableData[0].value : '1',
        hasFewPiecesLeft: data.fewItemsLeft || false,
        productUrl: data.link || '',
    };
};
//# sourceMappingURL=getAddToBagVerificationCompositionProduct.js.map